"use client";

import { TRANSITION_DURATION } from "@/components/gl/GLBackground";
import { events } from "../common/events";
import { wait } from "../lib/common";
import emitter from "../lib/emitter";
import { useGlobalStore } from "../store/global";
import { useRouter, usePathname } from "next/navigation";
import { useCallback } from "react";
import { isBrowser } from "../lib/platform";
import { useIsClient } from "../lib/hooks/useIsClient";
import { useDetectViewTransitionAPI } from "mono/lib/hooks/useDetectCapabilites";
import Link from "next/link";

// TODO: Fix this, no arbitrary value, but truly wait
export const WAIT_DURATION = 1400;

export const handleRouteChange = async ({
  href,
  router,
  isViewTransitionAPI,
}) => {
  try {
    useGlobalStore.getState().lenis.stop();
    emitter.emit(events.ROUTE_CHANGE_START, { route: href });

    await wait(TRANSITION_DURATION);
    router.push(href);

    // If view transition API is not available, we need to wait for the page to load
    // if (!isViewTransitionAPI) {
    //   useGlobalStore.getState().lenis?.scrollTo?.(0, { immediate: true });
    //   window.scrollTo(0, 0);
    //   window.history.scrollRestoration = "manual";
    //   await wait(WAIT_DURATION);
    //   emitter.emit(events.ROUTE_CHANGE_COMPLETE, { route: href });
    // }

    // if (href !== "/projects") {
    //   useGlobalStore.getState().lenis.start();
    // }
  } catch (error) {
    console.error("Navigation error:", error);
    useGlobalStore.getState().lenis.start();
  }
};

export const TransitionLink = ({ href = "/", children, enabled = true }) => {
  const router = useRouter();
  const pathname = usePathname();
  const isClient = useIsClient();
  const isViewTransitionAPI = useDetectViewTransitionAPI();

  const shouldStartAnimation = useCallback(
    (e) => {
      // Check if it's a left mouse click without any keyboard modifiers
      if (e.button === 0 && !e.ctrlKey && !e.shiftKey && !e.metaKey) {
        if (href === pathname) {
          return false;
        }
        return true;
      }

      // Middle mouse button click
      if (e.button === 1) return false;

      // Right mouse button click
      if (e.button === 2) return false;

      // Accessibility event
      if (e.type === "click" && e.detail === 0) return true;

      return false;
    },
    [href, pathname]
  );

  const handleClick = async (e) => {
    e.preventDefault();
    if (shouldStartAnimation(e)) {
      await handleRouteChange({ href, router, isViewTransitionAPI });
    }
  };

  const shouldDisableLink = useCallback(
    (url) => {
      if (!isBrowser()) return {};
      const isSameRoute = url === pathname;

      return {
        style: {
          pointerEvents: isSameRoute ? "none" : "auto",
          cursor: isSameRoute ? "default" : "pointer",
        },
      };
    },
    [pathname]
  );

  // if (isViewTransitionAPI)
  //   return (
  //     <Link
  //       {...shouldDisableLink(href)}
  //       onClick={() => {
  //         emitter.emit(events.ROUTE_CHANGE_START, { route: href });
  //       }}
  //       href={href}
  //     >
  //       {children}
  //     </Link>
  //   );

  if (!enabled || !isClient) return <>{children}</>;

  return (
    <a
      href={href}
      style={{ cursor: "pointer" }}
      {...shouldDisableLink(href)}
      onClick={handleClick}
      onKeyDown={handleClick}
      tabIndex={0}
    >
      {children}
    </a>
  );
};
